import * as React from 'react';

import FileWord16 from './FileWord16';

export const fileWord16 = () => <FileWord16 />;

export default {
    title: 'Icon|Fill|FileWord16',
    component: FileWord16,
    parameters: {
        notes: "`import FileWord16 from 'box-ui-elements/es/icon/fill/FileWord16';`",
    },
};
